<template lang="pug">
.order-container.fix(:class="{ 'page-break': pageBreak }" :style="{ width, height }")
  div
    .container-header(v-if="!change.isDropshipping")
      img.logo(:src="`${imagePath}/others/print-return-${change.brand}.png`")
      .sender-info-container
        .sender-info.capitalize {{ data[change.brand].name  }} - {{ data[change.brand].documentNumber }}
        .sender-info.capitalize {{ data[change.brand].address }} - {{ data[change.brand].phone }}

    .order-total(v-if="change.methodPay === 'cod' || change.cod") Cobrar Paquete: {{ money(total - discount + addons) }}

    .order-info
      .qr-container
        QRCode(:text="'c' + change.change" width="60")
      .info-principal
        //img.order-conveyor(v-if="change.conveyor && (change.conveyor !== 'sahet' && change.conveyor !== 'bassica')" :src="`${imagePath}/conveyors/${change.conveyor}.png`")
        .order.uppercase C{{ change.change }} (Cambio)
        .order-location.capitalize.no-wrap {{ locationLabel }}
        .cod-delivery(v-if="change.methodPay === 'cod' || change.cod || totalCOD > 0") Cobrar Paquete: {{ money(totalCOD) }}
        .cod-delivery(v-if="(change.methodPay === 'dropshipping' || change.isWholesaler) && change.userPayConveyor") Envío al Cobro

      .info-principal-order
        .info-principal-order-container
          .order.uppercase {{ change.order }}
        .qr-container
          QRCode(:text="change.order" width="60")

    .buyer-info
      .buyer-name.capitalize
        span.dark Nombre:
        span  {{ buyerRemit.name }}
      .buyer-phones
        span.dark Tel:
        span  {{ buyerRemit.phones.join(', ') }}
      .buyer-address.capitalize
        span.dark Dir:
        span.uppercase  {{ buyerRemit.address }}

      .buyer-address.capitalize.dark(v-if="observationsDelivery.length")
        span Importante:
        span(v-for="observation in observationsDelivery")  {{ observation.observation }}.

  .order-side-label
    .order-side-label-text
      span.order-side-label-name(v-if="sideName") {{ sideName }}
      span.order-side-label-number {{ sideNumber }}
</template>

<script>
import mForm from '@/mixins/form'
import mFilters from '@/mixins/filters'
import QRCode from '@/components/elements/QRCode'
import { getBuyerRemitFromOrder } from '@/helpers/remit'

export default {
  name: 'OrderPrintReturnAddress',

  mixins: [mForm, mFilters],

  components: { QRCode },

  props: {
    change: Object,
    pageBreak: Boolean,
    remitOnly: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '10cm'
    },
    height: {
      type: String,
      default: '10cm'
    }
  },

  data () {
    return {
      deliverySchedule: {
        '8-21': '🌞 8:00 a.m. - 🌚 9:00 p.m.',
        '8-20': '🌞 8:00 a.m. - 🌛 8:00 p.m.',
        '8-13': '🌞 8:00 a.m. - 😎 1:00 p.m.',
        '13-20': '😎 1:00 p.m. - 🌛 8:00 p.m.',
        '13-21': '😎 1:00 p.m. - 🌚 9:00 p.m.'
      }
    }
  },

  computed: {
    totals () {
      return this.getTotals(this.change.cart)
    },

    total () {
      return this.getTotal(this.change, this.totals)
    },

    discount () {
      return this.getDiscount(this.change, this.total)
    },

    addons () {
      return this.getAddons(this.change)
    },

    data () {
      return this.$store.state.variables.data
    },

    quantitySale () {
      return 3
    },
    observationsDelivery () {
      if (!this.change.observations || !this.change.observations.length) return []
      return this.change.observations.filter(observation => observation.type === 'delivery')
    },

    buyerRemit () {
      return getBuyerRemitFromOrder(this.change, { remitOnly: this.remitOnly })
    },

    totalCOD () {
      const change = this.change
      const { payManual } = change
      let total = 0

      for (let i = 0; i < payManual.length; i++) {
        const pay = payManual[i]

        if (pay.methodPay === 'cod') total += pay.value || 0
      }

      return total
    },

    sideNumber () {
      const orderId = String(this.change.order || this.change.change || '')
      return orderId.replace(/\D/g, '').slice(-3) || orderId.slice(-3)
    },

    sideName () {
      const firstName = (this.buyerRemit.name || '').trim().split(/\s+/)[0] || ''
      return firstName.slice(0, 8)
    },

    locationLabel () {
      const location = (this.buyerRemit.location || '').trim()
      const department = (this.buyerRemit.department || '').trim()

      if (!department || location.toLowerCase() === department.toLowerCase()) return location

      return `${location} - ${department}`
    }
  }
}
</script>

<style lang="stylus" scoped>
.order-container
  background-color white
  color black
  width 10cm
  height 7.5cm
  display flex
  padding 3mm calc(3mm + 14mm) 3mm 3mm
  vertical-align top
  border 1px dashed black
  border-radius 3mm
  margin 3mm
  align-items center
  position relative
  overflow hidden

.container-header
  display flex
  align-items center

.logo
  height 4mm
  display block
  margin-bottom 1mm

.sender-info-container
  border-left .5mm solid black
  padding-left 2mm
  margin-left 2mm

.sender-info
  font-size 3mm

.order-info
  display flex
  align-items center

.order
  font-size 6mm
  font-weight 600

.order-conveyor
  height 4mm
  width auto
  filter brightness(0)

.order-location
  font-size 4mm
  font-weight 600

.order-total
  font-size 3mm
  margin-top 3mm
  font-weight 600
  text-decoration underline

.order-observations
  margin-top 3mm
  font-size 3mm
  list-style-type upper-alpha

.order-observation
  padding 0em 0 0em 1em

.order-observation > li
  list-style decimal

.buyer-name, .buyer-phones, .buyer-address, .buyer-dni
  font-size 3mm

.fix
  page-break-inside avoid

.cod-delivery
  font-size 3mm
  border-bottom 1mm solid black
  display inline-block
  padding .2mm 0
  font-weight 600

.wait
  font-size 3mm
  text-decoration underline
  font-weight 600

.container-zimple
  display flex
  gap 2mm

.page-break
  break-inside avoid

.info-principal-order
  position relative
  display flex
  justify-content center
  align-items center
  flex-direction column
  margin-left 10mm

.info-principal-order .qr-container
  position relative
  margin-top -1em
  z-index 1

.info-principal-order-container
  position relative
  z-index 2

.order-side-label
  position absolute
  right 3mm
  top 0
  bottom 0
  width 14mm
  display flex
  align-items center
  justify-content center
  pointer-events none

.order-side-label-text
  display flex
  flex-direction column
  align-items center
  gap 0.6mm
  transform rotate(-90deg)
  white-space nowrap
  line-height 1
  text-transform uppercase

.order-side-label-name
  font-size 5mm
  font-weight 700
  letter-spacing .3mm

.order-side-label-number
  font-size 7mm
  font-weight 800
  letter-spacing .4mm

@media print
  .order-container
    border none
    margin 0
    border-top .5mm solid black
    border-radius 0
</style>



// WEBPACK FOOTER //
// src/components/pages/print/ChangePrintReturnAddress.vue